export enum IrbEditorsEvents {
    LOAD = "IRBEDITORSEVENTS.LOAD",
    IS_MODIFIED = "IRBEDITORSEVENTS.IS_MODIFIED",
    IS_NOT_MODIFIED = "IRBEDITORSEVENTS.IS_NOT_MODIFIED",
    CANCEL = "IRBEDITORSEVENTS.CANCEL",
    SAVE = "IRBEDITORSEVENTS.SAVE",
    SAVE_SUCCESS = "IRBEDITORSEVENTS.SAVE_SUCCESS",
    SAVE_ERROR = "IRBEDITORSEVENTS.SAVE_ERROR",
    UNSAVED_CHANGES = "IRBEDITORSEVENTS.UNSAVED_CHANGES",
    CLOSE_WITHOUT_SAVE = "IRBEDITORSEVENTS.CLOSE_WITHOUT_SAVE",
    SAVE_START = "IRBEDITORSEVENTS.SAVE_START",
    HIDE_WAIT = "IRBEDITORSEVENTS.HIDE_WAIT",
    REVERT_CHANGES = "IRBEDITORSEVENTS.REVERT_CHANGES",
    CALL_PENDING_FUNCTION = "IRBEDITORSEVENTS.CALL_PENDING_FUNCTION",
    CLOSE = "IRBEDITORSEVENTS.CLOSE",
    DATA_CHANGED = "IRBEDITORSEVENTS.DATA_CHANGED",
    DATA_LOADED = "IRBEDITORSEVENTS.DATA_LOADED",
    CHANGE_OF_ISVALID = "CHANGE_OF_ISVALID",
    WARN_SUCCESS = "IRBEDITORSEVENTS.WARN_SUCCESS",

    /* TODO: Editor specific events should not be included here */
    ASSIGN_ACCOUNTS = "IRBEDITORSEVENTS.ASSIGN_ACCOUNTS",
    SHOW_ACCOUNT_EDIT = "IRBEDITORSEVENTS.SHOW_ACCOUNT_EDIT",
    ACCOUNT_SAVED = "IRBEDITORSEVENTS.ACCOUNT_SAVED",
    PF_RESTRICTIONS_REFRESH = "IRBEDITORSEVENTS.PF_RESTRICTIONS_REFRESH",
    SHOW_EDIT_CREATE_REBALANCE = "IRBEDITORSEVENTS.SHOW_EDIT_CREATE_REBALANCE",
    SHOW_IMPORT_EXTRA_CASH_SETTINGS = "IRBEDITORSEVENTS.SHOW_IMPORT_EXTRA_CASH_SETTINGS",
    SHOW_LOSS_PRIORITY_SETTINGS_DIALOG = "IRBEDITORSEVENTS.SHOW_LOSS_PRIORITY_SETTINGS_DIALOG",
    REFRESH_HARVEST_TAX_LOSS_GRID = "IRBEDITORSEVENTS.REFRESH_HARVEST_TAX_LOSS_GRID",
    REFRESH_INCLUDED_PORTFOLIO_GRID = "IRBEDITORSEVENTS.REFRESH_INCLUDED_PORTFOLIO_GRID",
    SHOW_INVERSE_ACCOUNT_TYPE_DIALOG = "IRBEDITORSEVENTS.SHOW_INVERSE_ACCOUNT_TYPE_DIALOG",
    SHOW_BUY_MULTIPLE_REPLACEMENT = "IRBEDITORSEVENTS.SHOW_BUY_MULTIPLE_REPLACEMENT",
    UPDATE_FROM_BUY_MULTIPLE_REPLACEMENT = "IRBEDITORSEVENTS.UPDATE_FROM_BUY_MULTIPLE_REPLACEMENT",
    SHOW_MULTIPLE_PORTFOLIO_SELECTION_DIALOG = "IRBEDITORSEVENTS.SHOW_MULTIPLE_PORTFOLIO_SELECTION_DIALOG",
    SAVE_MULTIPLE_PORTFOLIOS="IRBEDITORSEVENTS.SAVE_MULTIPLE_PORTFOLIOS",
    SHOW_IMPORT_LOSS_PRIORITY_SETTINGS_DIALOG="IRBEDITORSEVENTS.SHOW_IMPORT_LOSS_PRIORITY_SETTINGS_DIALOG",
    SHOW_IMPORT_LOSS_PRIORITY_SETTINGS_ERROR_DIALOG="IRBEDITORSEVENTS.SHOW_IMPORT_LOSS_PRIORITY_SETTINGS_ERROR_DIALOG",
    REFRESH_LOSS_PRIORITY_GRID="IRBEDITORSEVENTS.REFRESH_LOSS_PRIORITY_GRID",
    SHOW_MMC_MARKETING_DOCUMENTS ="IRBEDITORSEVENTS.SHOW_MMC_MARKETING_DOCUMENTS",
    MMC_MARKETING_DOCUMENT_UPLOADED ="IRBEDITORSEVENTS.MMC_MARKETING_DOCUMENT_UPLOADED",
    SHOW_MOVE_SECURITIES_WARNINGS_DIALOG="IRBEDITORSEVENTS.SHOW_MOVE_SECURITIES_WARNINGS_DIALOG",
    SHOW_MOVE_SECURITIES_GRID_DATA_DIALOG ="IRBEDITORSEVENTS.SHOW_MOVE_SECURITIES_GRID_DATA_DIALOG",
    SHOW_MOVE_SECURITIES_USAGE_REVIEW_DIALOG ="IRBEDITORSEVENTS.SHOW_MOVE_SECURITIES_USAGE_REVIEW_DIALOG",
    SHOW_REBALANCE_TYPE_INFO_DIALOG = "IRBEDITORSEVENTS.SHOW_REBALANCE_TYPE_INFO_DIALOG"
}
